import { atom } from "jotai";
import { SiteType } from "@/types";
import { atomWithToggle } from "@/utils";

const _atom = atom<SiteType | null>(null);

export const siteAtom = atom(
  (get) => get(_atom),
  (get, set, newSite: SiteType | null) => {
    set(_atom, newSite);
  },
);
export const siteSidebarSearchValueAtom = atom("");
export const siteSidebarSearchVisibilityAtom = atomWithToggle(false);
